module.exports = __webpack_public_path__ + "static/plantify3-73225ec66b0b8437e68597c993e25496.jpg";